module.exports = __webpack_public_path__ + "h5/img/404.55c435f2.png";